import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import { Button } from "@mui/material";
import styles from "./Modal.module.css";

// eslint-disable-next-line react/prop-types
const Modal = ({ children, onClose, onConfirm, containerStyles }) => {
  const modalRoot = document.getElementById("modal-root");

  // Close modal with keyboard.
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!modalRoot) return null;

  return ReactDOM.createPortal(
    <div className={styles.wrapper} onClick={onClose}>
      <div
        style={containerStyles}
        className={styles.modal}
        onClick={(e) => e.stopPropagation()} // Avoid clicking on modal.
      >
        {children}

        <div className={styles.buttonsContainer}>
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>

          <Button variant="outlined" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export { Modal };
